import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { ClampWithTooltip } from "~/components/ClampWithTooltip/ClampWithTooltip";
import { FormatDateYearTime } from "~/lib/date";
import { DataTable } from "~/components/data-table";
import { ExceptionGroupExtension } from "~/operations";
import { ReviewStatusChip } from "./ReviewStatusChip";
import { Flex } from "~/components/Flex";

interface ExtensionHistoryTableProps {
  extensions?: ExceptionGroupExtension[];
}

export const ExtensionHistoryTable = ({
  extensions,
}: ExtensionHistoryTableProps) => {
  if (!extensions) return null;

  return (
    <Stack gap={1}>
      <Typography sx={{ fontWeight: 700, textTransform: "uppercase" }}>
        Extension History
      </Typography>
      <DataTable>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>Requested By</TableCell>
            <TableCell>Reviewed By</TableCell>
            <TableCell>Expiration Date</TableCell>
            <TableCell>Justification</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {extensions.map((ext, index) => (
            <TableRow key={index} hover>
              <TableCell>
                <ReviewStatusChip
                  status={ext.status}
                  isRemoved={false}
                  isActive={true}
                />
              </TableCell>
              <TableCell>
                <Flex flexDirection="column">
                  <Typography component="span" variant="body2" sx={{ mr: 1 }}>
                    {ext.author.name}
                  </Typography>
                  <Typography
                    component="span"
                    color="text.secondary"
                    variant="body2"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    {FormatDateYearTime(ext.createDate)}
                  </Typography>
                </Flex>
              </TableCell>
              <TableCell>
                <Flex flexDirection="column">
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    {ext?.reviewer?.name}
                  </Typography>
                  <Typography
                    component="span"
                    color="text.secondary"
                    variant="body2"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    {FormatDateYearTime(ext.reviewDate)}
                  </Typography>
                </Flex>
              </TableCell>
              <TableCell>
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {FormatDateYearTime(ext.validUntil)}
                </Typography>
              </TableCell>
              <TableCell sx={{ maxWidth: 560 }}>
                <ClampWithTooltip lines={2}>
                  {ext.justification || <i>No justification provided</i>}
                </ClampWithTooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </DataTable>
    </Stack>
  );
};

export default ExtensionHistoryTable;
